import {ValueObject} from '@s-ui/domain'

export class ReservationIdRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.adId
   * @param {String} data.userId
   * @param {String} data.name
   * @param {String} data.lastName
   * @param {String} data.email
   * @param {String} data.phone
   **/

  static validate({reservationId, validationError}) {
    const checkValidData = value => value !== null && value !== undefined && value !== ''

    if (!checkValidData(reservationId)) throw validationError(`Invalid user reservationId => ${reservationId}`)
  }
}
